import { render, staticRenderFns } from "./DashboardContributorsList.vue?vue&type=template&id=78c84c06&scoped=true&"
import script from "./DashboardContributorsList.vue?vue&type=script&lang=js&"
export * from "./DashboardContributorsList.vue?vue&type=script&lang=js&"
import style0 from "./DashboardContributorsList.vue?vue&type=style&index=0&id=78c84c06&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c84c06",
  null
  
)

export default component.exports